import Seo from "./seo";
import { useEffect } from "react";
import Lp_Header from "./lp/lp_header";
import LpFooter from "./lp/lp_footer";
import HeaderV2 from "./v2/header";
import FooterV2 from "./v2/footer";
import localFont from "next/font/local";
const sfproDisplay = localFont({
  src: [
    {
      path: "../public/assets/fonts/fonts-sf-pro/sf-pro-display-medium-webfont.woff2",
      weight: "510",
    },
    {
      path: "../public/assets/fonts/fonts-sf-pro/SF-Pro-Display-Bold.woff",
      weight: "600",
    },
    {
      path: "../public/assets/fonts/fonts-sf-pro/sfprotext-bold-webfont.woff2",
      weight: "700",
    },
  ],
  variable: "--font-sfpro-display",
  display: "swap",
});
const sfproText = localFont({
  src: [
    {
      path: "../public/assets/fonts/fonts-sf-pro/sfprotext-regular-webfont.woff2",
      weight: "400",
    },
  ],
  variable: "--font-sfpro-text",
  display: "swap",
});
export default function Layout({
  isHomePage,
  children,
  ogImage,
  pageTitle,
  uri,
  metaTitle,
  metaDesc,
  metaRobotsNoindex,
  metaRobotsNofollow,
}) {
  let openGraphImage =
    ogImage != undefined
      ? ogImage
      : "https://middleware.io/wp-content/uploads/2024/08/middleware-observability-thumbnail.png";

  if (openGraphImage.indexOf("/backend/") > -1) {
    openGraphImage = openGraphImage.split("/backend/").join("/");
  }

  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (let registration of registrations) {
          registration.unregister();
        }
      });
    }
  }, []);
 
  const setCookie = (cname:string, cvalue:string, exdays:number) => {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;domain=.middleware.io;SameSite=None;Secure";
  }
 
  useEffect(() => {
    const currentUrl = window.location.href;
    setCookie("mw_website_current_url",encodeURIComponent(currentUrl),365)
  },[pageTitle]);
  return (
    <>
      {/*Google Tag Manager (noscript)*/}
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-KKBGSWD"
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
        ></iframe>
      </noscript>

      <div
        className={`global-wrapper-v2 ${pageTitle ? pageTitle : ""} ${
          sfproDisplay.variable
        } ${sfproText.variable}`}
        data-is-root-path={isHomePage}
      >
        {/*<Seo uri={uri} ogImage={openGraphImage} title={pageTitle ? pageTitle :''} metaTitle={metaTitle ? metaTitle : ""} metaDesc={metaDesc} description={metaDesc} robots={`${metaRobotsNoindex}, ${metaRobotsNofollow}`} />*/}
        <HeaderV2 />

        <main>{children}</main>
        <FooterV2 />
      </div>
    </>
  );
}
